import { useLayoutEffect, useRef, type ReactNode } from "react";
import { Badge } from "@mui/material";
import { navBadgeLabel } from "@/utils/vulnerabilityCopy.ts";

/** The shell takes a plain label, so the count joins the item's accessible name on its button. */
export default function CountedNavIcon({ icon, label, count }: {
  readonly icon: ReactNode;
  readonly label: string;
  readonly count: number;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  useLayoutEffect(() => {
    const item = ref.current?.closest("button, a");
    item?.setAttribute("aria-label", `${label}, ${navBadgeLabel(count)}`);
    return () => item?.removeAttribute("aria-label");
  }, [label, count]);
  return <Badge ref={ref} badgeContent={count} color="error" max={99}>{icon}</Badge>;
}
